module.exports = __webpack_public_path__ + "static/media/Life-sky-blue.5ca33079.svg";